import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-live-badge',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './live-badge.component.html',
})
export class LiveBadgeComponent {
  isLive = input.required<boolean | null>();
  label = input<string>('NOW');
  additionalClasses = input<string>('');
}
